import { createAction } from 'redux-actions';

import { EmployeeStatus } from './load-org-employees-by-status';

const action = createAction('SET_ORG_EMPLOYEES_BY_STATUS_DIRTY');
export const setOrgEmployeesDirty = (orgId: number, employeeStatus: EmployeeStatus) =>
  action({ orgId, employeeStatus });
